/**
 * Copyright 2018 Samsung Electronics All Rights Reserved
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import localforage from 'localforage';
import { AuthStorage, AuthCredential } from '@swuif/auth';

export const sbaasAuthStorage = (
  name: string,
  skipInitialLoad?: boolean,
): AuthStorage => {
  const storage = localforage.createInstance({
    name,
    storeName: 'auth',
    description: `SWUIF Auth Storage for ${name}`,
  });
  const key = 'credential';

  return {
    skipInitialLoad,
    load: () => storage.getItem<AuthCredential | undefined>(key),
    store: credential =>
      credential ? storage.setItem(key, credential) : storage.removeItem(key),
  };
};
